import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import DetailsHolder from '../DetailsHolder'
import Timetable from '../../../College/TimetableForm'
import FormDropdown from '../../../../Components/FormField/FormDropdown'
import { API } from '../../../../API'

const CollegeDetailTimetable = ({ college }) => {
  const timeRef = React.useRef()

  const [bookingCount, setBookingCount] = useState([])

  useEffect(() => {
    API.countBookingForClassList(college.classes.map(classItem => classItem._id))
      .then(result => {
        setBookingCount(result?.data?.data)
      })
      .catch(error => {
        console.log("error on count: ", error)
      })
  }, [])

  const getRefNameList = () => {
    var refList = []

    for (var i = 0; i < college.classes.length; i++) {
      if (college.classes[i]) {
        const refName = {
          name:
            'reference_name' in college.classes[i]
              ? college.classes[i].reference_name
              : 'default_ref',
          value: college.classes[i]._id,
        }
        refList.push(refName)
      }
    }

    return refList
  }

  const refNameChanged = (e) => {
    timeRef.current.swapTab(e.target.value)
  }

  const buildRefNameOption = () => {
    const optionList = []
    const refNameList = getRefNameList()
    if (refNameList) {
      refNameList.map((item) => {
        optionList.push(<option value={item.value}>{item.name}</option>)
      })
    }

    return optionList
  }

  return (
    <DetailsHolder college={college} activePath='/CollegeDetailTimetable'>
      {college.classes.length > 0 && (
        <div className='ml-2 col-3'>
          <FormDropdown label='Reference Name List: ' onChange={refNameChanged}>
            {buildRefNameOption()}
          </FormDropdown>
        </div>
      )}
      <div>
        {college.classes.length == 0 ? (
          <div className='absolute-align-items-center'>
            <p>Currently there is no data available.</p>
          </div>
        ) : (
          <Timetable
            classes={college.classes}
            campuses={college.campuses}
            institution={college.institution}
            user={college.user}
            ref={timeRef}
            personnels={college.personnel}
            bookingCount={bookingCount}
          />
        )}
      </div>
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
  }
}

export default connect(mapStateToProps)(CollegeDetailTimetable)
